import { toast } from "sonner";

const toastOptions = {
  duration: 2000,
  closeButton: true,
  expand: true,
  position: "top-right" as const,
  classNames: {
    toast: "toast-wrap",
  },
};

export const Toast = (message: string) => {
  toast(message, {
    ...toastOptions,
    ...{
      style: {
        background: "var(--gray-50)",
        border: "none",
      },
    },
  });
};

export const SuccessToast = (message: string) => {
  toast.success(message, {
    ...toastOptions,
    ...{
      style: {
        background: "#e4fcf6",
        color: "var(--green)",
        border: "none",
      },
    },
  });
};

export const ErrorToast = (message: string) => {
  toast.error(message, {
    ...toastOptions,
    ...{
      style: {
        background: "var(--red-100)",
        color: "var(--red)",
        border: "none",
      },
    },
  });
};
